// Header switch for the grey pre-fill. Shown only when a prediction was applied. Off puts every
// still-predicted answer back to what it was before the prediction; answers the user changed
// stay either way, and switching it back on restores the rest.

import { useAnswers } from "../state/AnswersContext";

export default function PredictionToggle() {
  const { prediction, setPredictionOn } = useAnswers();
  if (!prediction) return null;
  const src = prediction.refineSource ?? prediction.launchSource;
  const when = src.createdAt ? new Intl.DateTimeFormat(undefined, { dateStyle: "medium" }).format(new Date(src.createdAt)) : "";
  const from =
    src.kind === "fieldwise"
      ? `${src.name}, answer by answer`
      : src.kind === "legacy"
      ? `this customer's order ${src.name}${when ? `, ${when}` : ""}`
      : src.basis === "customer"
        ? `this customer's ${src.name}${when ? ` (${when})` : ""}`
        : `${src.name}${src.customerName ? ` for ${src.customerName}` : ""}${when ? ` (${when})` : ""}`;
  // An MB burner mirrored from the one configured before it.
  const mirror =
    prediction.mirrorRole === "middle"
      ? `Grey answers are ${src.name} moved to the middle: its side inlets on the front panel. Fill in the highlighted In and Up distances.`
      : prediction.mirrorRole === "opposite"
        ? `Grey answers mirror ${src.name}, the opposite side: left and right swapped where marked.`
        : "";
  return (
    <label
      className={`cpq-predict-toggle${prediction.on ? " is-on" : ""}`}
      title={
        prediction.on
          ? `${mirror || `Grey answers are predicted from ${from}.`} Change any you need; switch off to clear them.`
          : "Predicted answers are off. Switch on to fill them back in."
      }
    >
      <input
        type="checkbox"
        role="switch"
        checked={prediction.on}
        onChange={(e) => setPredictionOn(e.target.checked)}
      />
      <span className="cpq-predict-toggle-track" aria-hidden />
      <span>Prediction</span>
    </label>
  );
}
